module.exports = __webpack_public_path__ + "static/media/icon-wallet.4c913b43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-wallet.svg
// module id = 268
// module chunks = 3